<div (dndDrop)="onDrop($event, playlists)" dndDropzone dndEffectAllowed="all">
    <div dndPlaceholderRef> </div>

    <div *ngFor="let item of playlists; let i = index" [dndDraggable]="item" dndEffectAllowed="all"
        (dndMoved)="onDragged(item, playlists)">
        <nz-card class="list-card mt-2">
            <div nz-row [nzGutter]="[16]">
                <div nz-col nzSpan="12">
                    <div class="d-flex align-items-center">
                        <div class="cursor-move mr-2">
                            <img src="./assets/icons/re-order.svg" alt="icon">
                        </div>
                        <div class="mr-2 cursor-pointer"
                            (click)="$event.stopPropagation(); previewPlaylist.emit(item)"
                            nz-tooltip nzTooltipTitle="Preview"
                            [ngClass]="{'list-img-wrapper': !item.urlError, 'list-default-wrapper': item.urlError}">
                            <img *ngIf="!item.urlError"
                                [src]="item.thumbnailUrl || item.defaultUserMediaAppUrl"
                                alt="playlist-icon"
                                (error)="onUrlError(item)"
                                [ngClass]="{'hidden': item.urlError}">
                        </div>
                        <span class="text-ellipsis" nz-tooltip [nzTooltipTitle]="item.name">{{item.name}}</span>
                    </div>
                </div>
                <div nz-col nzSpan="6" class="align-items-center">
                    {{item.userMediaAppCount}} media
                </div>
                <div nz-col nzSpan="6" class="d-flex align-items-center justify-content-end">
                    <span nz-icon nzType="eye" nzTheme="outline"
                        (click)="previewPlaylist.emit(item)"
                        class="cursor-pointer mr-2 pointer-events-all"></span>
                    <span (click)="editPlaylist.emit(item)"
                        class="cursor-pointer d-flex align-items-center mr-2 pointer-events-all">
                        <img src="./assets/icons/edit.svg" alt="edit-icon" class="filter_darkmode">
                    </span>
                    <span nz-icon nzType="delete" nzTheme="outline"
                        (click)="onRemove(item)" class="cursor-pointer pointer-events-all"></span>
                </div>
            </div>
        </nz-card>
    </div>
</div>
